module.exports = __webpack_public_path__ + "static/media/ambe.76e8afd7.jpg";